export default {
  title: 'Meldingen inschakelen voor exclusieve deals & updates',
  description: 'Ontvang bestelupdates in realtime. Volg de bezorgstatus. Exclusieve acties & voordelen.',
  buttons: {
    confirm: 'Inschakelen',
    cancel: 'Niet nu',
  },
};
